import * as sidecar from "@/lib/sidecar/config"

export const PRIVY_APP_ID = sidecar.getValue("privyAppId")
export const PRIVY_CLIENT_ID = sidecar.getValue("privyClientId")
